module.exports = __webpack_public_path__ + "static/media/productItem1.f5e96bda.png";